import lessRequire from '../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import isNumber from 'lodash/isNumber';

import { baseUrl } from '../../config/route-entry-point';

lessRequire('modules/shared/switch.less');

export default function Switch ({
	links, onSwitch, intl
}) {
	return (
		<div className="header-switch">
			<div className="header-switch__links font-proxima-nova-semibold">
				{ links.map((link, i) => (
					<Link key={i}
						to={baseUrl(link.url)}
						className={link.className}
						activeClassName="active"
						onClick={onSwitch ? e => onSwitch(link.url) : null}
					>
						{ intl(link.title) }
						{ link.secondTitle
							? <span>{ isNumber(link.secondTitle) ? link.secondTitle : intl(link.secondTitle) }</span>
							: ''
						}
					</Link>
				)) }
			</div>
		</div>
	);
}

Switch.propTypes = {
	links: PropTypes.array,
	onSwitch: PropTypes.func,
	intl: PropTypes.func
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/switch.js